import { isNavigationFailure } from 'vue-router'

// A modal page cancels the route change. Vue Router rejects that cancellation.
// The submit already succeeded, so the rejection is not a failed save or login.

function pushAppPath (router, path) {

  if (!router || !path) return Promise.resolve()

  return Promise.resolve(router.push(path)).catch((error) => {

    if (!isNavigationFailure(error)) throw error
  })
}

export { pushAppPath }
